import {useLocation, useNavigate} from 'react-router-dom';
import OTP from '../../common/components/otp/OTP';
import {useMutation} from '../../../../common/hooks/QueryHooks';
import {OTPValidated} from '../../common/components/otp/Types';
import {routes} from '../../../../routing/routes';

export default function VerifyForgot() {
	const navigate = useNavigate();
	const location = useLocation();
	const {mutate} = useMutation<OTPValidated>('/enterpriser/auth/verify-otp');

	const email = location.state === null ? undefined : (location.state.email as string);

	const goBack = () => {
		navigate(routes.forgot);
	};

	if (email === undefined) {
		goBack();
		return null;
	}

	const validate = async (code: string) => {
		const data = {email, code};
		const res = await mutate({data});
		navigate(routes.reset, {state: {email, code: res.code}});
	};

	return <OTP email={email} onValidate={validate} onBack={goBack} />;
}
